import React from 'react'; //, { useState } 
import '../styles/PacDebt.css';  // Import the CSS file

const Footer = () => {
    return (
      <footer className="footer">
        <label>© {new Date().getFullYear()}  Pacific Debt Relief. All rights reserved. </label> 
        <span className='badge'>Core App 4.18.0</span>
      </footer>
    )
    
    };
    
export default Footer;
